import { createStyles, makeStyles } from '@material-ui/core';
import { white } from '@signaturit/react-components-library';

export const useSideNavigationMenuItemStyles = makeStyles(() =>
    createStyles({
        items: {
            width: 224,
            height: '100%',
            color: white,
            overflow: 'hidden',
        },
        link: {
            width: '100%',
            color: `${white} !important`,
            textDecoration: 'none',

            '&:hover': {
                textDecoration: 'underline',
            },
        },
    })
);
